import { PaginatedResponse } from './paginated-response';
import { Permission } from './permission';
import { BillTo } from './bill-to';
import { Address } from './address';

export class Market {
  accountNumber: string;
  id: string;
  name: string;
  customerId: string;
  customerName: string;
  description: string;
  tier2ApprovalAmount: number;
  triggerTier2ApprovalIfItemNotOnMasterCatalog: boolean;
  marketPermissions: Permission[];
  marketTasks: MarketTask[];
  marketInputTasks: MarketInputTask[];
  type: string;
  typeOutput: string;
  adminMailStopEmail: any;
  associationCode: string;
  billingAddress: BillTo;
  shippingAddresses: Address[];
  isMarketPermissionsModified: boolean;
  locationCode: string;
  generateReadoutReport: boolean;
  purchasePlanFlag: boolean;

  constructor(data: any = {}) {
    this.accountNumber = data.accountNumber;
    this.id = data.id;
    this.name = data.name || '';
    this.customerId = data.customerId;
    this.customerName = data.customerName;
    this.description = '';
    this.marketPermissions = [];
    this.marketTasks = [];
    this.type = data.type;
    this.adminMailStopEmail = data.adminMailStopEmail;
    this.locationCode = data.locationCode;
    this.generateReadoutReport = data.generateReadoutReport;
    this.purchasePlanFlag = data.purchasePlanFlag;
  }
}

export class PaginatedMarketDTO extends PaginatedResponse {
  records: Market[];
}

export class MarketAccount {
  AccountNumber: string;
  BillToAddress: BillToAddressDTO;

  constructor(data: any = {}) {
    this.AccountNumber = data.AccountNumber || '';
    this.BillToAddress = data.BillToAddress || new BillToAddressDTO();
  }
}

export class BillToAddressDTO {
  Name: string;
  Address1: string;
  Address2: string;
  City: string;
  Country: {
    Name: string,
    IsoNumericCode: string,
    IsoThreeAlphaCode: string,
    IsoTwoAlphaCode: string
  };
  PostalCode: string;
  Province: string;
  State: {
    Abbreviation: string;
    Name: string;
  };
  ZipCode1: string;
  ZipCode2: string;
}

export class TaskType {
  taskName: string;
  taskType: string;
}

export class MarketTask {
  id: string;
  marketTaskName: TaskType;
}

export class MarketInputTask {
  id: string;
  taskName: string;

  constructor(id: string, taskName: string) {
    this.id = id;
    this.taskName = taskName;
  }
}

export class MarketTeamUserDetailsByType {
  id: string;
  targetType: string;
  roleType: number;

  constructor(id: string, targetType: string, roleType: number) {
    this.id = id;
    this.targetType = targetType;
    this.roleType = roleType;
  }
}

export class MarketPermissionDetails {
  id: string;
  name: string;
}

export class MarketTeamUserDetailsOutput {
  id: string;
  permissionDetails: MarketPermissionDetails[];
}

export class MarketsInput {
  marketIds: string[];
  searchTerm: string;
  orgId: string;
}

export class StateAbbreviation {
  abbr: string;
  name: string;
}



// WEBPACK FOOTER //
// /codebuild/output/src3408204168/src/bitbucket.org/tesscotds/webclient/src/api/models/market-model.ts